/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportSession } from './ImportSession';
import {
    ImportSessionFromJSON,
    ImportSessionFromJSONTyped,
    ImportSessionToJSON,
    ImportSessionToJSONTyped,
} from './ImportSession';
import type { Order } from './Order';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
    OrderToJSONTyped,
} from './Order';
import type { OSMBuilding } from './OSMBuilding';
import {
    OSMBuildingFromJSON,
    OSMBuildingFromJSONTyped,
    OSMBuildingToJSON,
    OSMBuildingToJSONTyped,
} from './OSMBuilding';
import type { CompanyMetaDataLLM } from './CompanyMetaDataLLM';
import {
    CompanyMetaDataLLMFromJSON,
    CompanyMetaDataLLMFromJSONTyped,
    CompanyMetaDataLLMToJSON,
    CompanyMetaDataLLMToJSONTyped,
} from './CompanyMetaDataLLM';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Company
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Company
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    rawCompanyData?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    fullAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    addition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    rawAddressData?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    lat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    lon?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof Company
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    importSessionId?: string | null;
    /**
     * 
     * @type {ImportSession}
     * @memberof Company
     */
    importSession?: ImportSession;
    /**
     * 
     * @type {Array<Order>}
     * @memberof Company
     */
    orders?: Array<Order> | null;
    /**
     * 
     * @type {OSMBuilding}
     * @memberof Company
     */
    osmBuilding?: OSMBuilding;
    /**
     * 
     * @type {CompanyMetaDataLLM}
     * @memberof Company
     */
    companyMetaDataLLM?: CompanyMetaDataLLM;
}

/**
 * Check if a given object implements the Company interface.
 */
export function instanceOfCompany(value: object): value is Company {
    return true;
}

export function CompanyFromJSON(json: any): Company {
    return CompanyFromJSONTyped(json, false);
}

export function CompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Company {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rawCompanyData': json['rawCompanyData'] == null ? undefined : json['rawCompanyData'],
        'fullAddress': json['fullAddress'] == null ? undefined : json['fullAddress'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'addition': json['addition'] == null ? undefined : json['addition'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'rawAddressData': json['rawAddressData'] == null ? undefined : json['rawAddressData'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'importSessionId': json['importSessionId'] == null ? undefined : json['importSessionId'],
        'importSession': json['importSession'] == null ? undefined : ImportSessionFromJSON(json['importSession']),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderFromJSON)),
        'osmBuilding': json['osmBuilding'] == null ? undefined : OSMBuildingFromJSON(json['osmBuilding']),
        'companyMetaDataLLM': json['companyMetaDataLLM'] == null ? undefined : CompanyMetaDataLLMFromJSON(json['companyMetaDataLLM']),
    };
}

export function CompanyToJSON(json: any): Company {
    return CompanyToJSONTyped(json, false);
}

export function CompanyToJSONTyped(value?: Company | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'name': value['name'],
        'description': value['description'],
        'rawCompanyData': value['rawCompanyData'],
        'fullAddress': value['fullAddress'],
        'street': value['street'],
        'number': value['number'],
        'addition': value['addition'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'country': value['country'],
        'rawAddressData': value['rawAddressData'],
        'lat': value['lat'],
        'lon': value['lon'],
        'externalId': value['externalId'],
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'importSessionId': value['importSessionId'],
        'importSession': ImportSessionToJSON(value['importSession']),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderToJSON)),
        'osmBuilding': OSMBuildingToJSON(value['osmBuilding']),
        'companyMetaDataLLM': CompanyMetaDataLLMToJSON(value['companyMetaDataLLM']),
    };
}

